import { api } from "../axios";
import { Client } from "../_interface/location";

export async function getClientById(clientId: number): Promise<Client> {
  const { data } = await api.get<Client>(`/client/${clientId}`);
  return data;
}
